import { LOGGED_OUT } from "./constants";
import { LoggedOutAction } from "./types";

export const LOGGED_IN_ORGANIZATION = "LOGGED_IN_ORGANIZATION";
export const SET_ORGANIZATION_INFO = "SET_ORGANIZATION_INFO";
export const LOGOUT_FROM_ORGANIZATION = "LOGOUT_FROM_ORGANIZATION";

export interface OrganizationState {
  organizationClientId: string;
  token: string;
  name: string;
  logoUri: string;
}

export interface LoggedInOrganizationAction {
  type: typeof LOGGED_IN_ORGANIZATION;
  payload: {
    token: string;
  };
}

export interface SetOrganizationInfoAction {
  type: typeof SET_ORGANIZATION_INFO;
  payload: {
    organization: {
      name: string;
      organizationClientId: string;
      logoUri?: string;
    };
  };
}

export interface LogoutFromOrganizationAction {
  type: typeof LOGOUT_FROM_ORGANIZATION;
}

export type AuthActionTypes =
  | LoggedInOrganizationAction
  | SetOrganizationInfoAction
  | LogoutFromOrganizationAction
  | LoggedOutAction;

const initialState: OrganizationState = {
  logoUri: "",
  name: "",
  organizationClientId: "",
  token: "",
};

export default function auth(state = initialState, action: AuthActionTypes): OrganizationState {
  if (action.type === LOGGED_IN_ORGANIZATION) {
    const { token } = action.payload;
    return {
      ...state,
      token,
    };
  }

  if (action.type === SET_ORGANIZATION_INFO) {
    const { organization } = action.payload;

    return {
      ...state,
      logoUri: organization.logoUri || "",
      name: organization.name || "",
      organizationClientId: organization.organizationClientId || "",
    };
  }

  if (action.type === LOGOUT_FROM_ORGANIZATION) {
    return {
      ...initialState,
    };
  }

  if (action.type === LOGGED_OUT) {
    return {
      ...initialState,
    };
  }

  return state;
}
